import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Card/Card'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/Form/Form'
import '@isceco/widget-library2/basic-elements/TextInput/TextInput'
import '@isceco/widget-library2/basic-elements/Textarea/Textarea'
import '@isceco/widget-library2/basic-elements/NumberInput/NumberInput'
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown'
import '@isceco/widget-library2/basic-elements/FileInput/FileInput'
import StatutenPruefungService from './StatutenPruefungService'
import FormComponent from "../../../../components/FormComponent";

export default class StatutenPruefung extends FormComponent {

  static ARTIKEL_PATTERN = '^[0-9\\-]+$';

  static DOCUMENT_LINKS = {
    de: 'https://www.bwo.admin.ch/dam/de/sd-web/cR74peKLBTm3/Gemeinnuetzigkeitsanforderungen_nach_WFG_2026-d.pdf',
    en: 'https://www.bwo.admin.ch/dam/de/sd-web/cR74peKLBTm3/Gemeinnuetzigkeitsanforderungen_nach_WFG_2026-d.pdf',
    it: 'https://www.bwo.admin.ch/dam/it/sd-web/cR74peKLBTm3/Gemeinnuetzigkeitsanforderungen_nach_WFG_2026-i.pdf',
    fr: 'https://www.bwo.admin.ch/dam/fr/sd-web/cR74peKLBTm3/Gemeinnuetzigkeitsanforderungen_nach_WFG_2026-f.pdf'
  };

  static I18N_KEYS = {
    ARTIKEL_ERROR_TEXT: 'form.input.artikel.error.text'
  };

  get translationFile() {
    return './views/WBF/BWO/statutenpruefung/i18n.json'
  }
  constructor(){
    super()
    this.selectedGrund = null;

  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  getTemplate() {
    const submitKey = this.preview ? 'form.button.submit' : 'form.button.preview'
    return html`
      <isceco-title id="page-title"
                    text="${this.i18n.translate('page.title')}"
      ></isceco-title>
      <eform-submit-status></eform-submit-status>
      <isceco-form id="statutenpruefung-form"
                   include-disabled
                   submit-button-text="${this.i18n.translate(submitKey)}"
                   @submit="${e => this._submit(e)}">

        <div slot="buttons">
          <isceco-button text="${this.i18n.translate('form.button.abort')}"
                         @click="${() => this.abort()}"
                         variant="secondary"
                         .disabled="${!this.preview}"
          ></isceco-button>
        </div>

        <div slot="form-elements" class="form-elements">
          ${this.getFormElements()}
        </div>
      </isceco-form>
    `
  }


  getFormElements = () => {
    return html`
      <isceco-card class="form-card">
        <p>
          ${this.i18n.translate('form.input.dokument.hinweis')}
          <a
            href="${this.getLocalizedDocumentLink()}"
            target="_blank"
            rel="noopener noreferrer"
          >
            ${this.i18n.translate('form.input.dokument.hinweis.link')}
          </a>
        </p>
          <div id="attachments">
            <isceco-file-input label="${this.i18n.translate('form.input.attachment')}"
                               name="attachments"
                               required
                               multiple
                               maxfiles="25"
                               maxsize="${this.fileMaxSize}"
                               .fileInputService="${this.fileInputService}"
                               .disabled="${this.preview}"
            ></isceco-file-input>
          </div>
          <isceco-dropdown
            label="${this.i18n.translate('form.input.dokument.grundBescheinigung')}"
            name="grundBescheinigung"
            required
            .readonly="${this.preview}"
            .i18n="${this.i18n}"
            .items="${this.grundBescheinigungItems}"
            @change="${this._updateGrundSonstigesRequiredState}"
            style="width: 100%">
          </isceco-dropdown>
          ${this.selectedGrund === 'SONSTIGES' ? html`
            <isceco-text-input
              name="grundSonstiges"
              label="${this.i18n.translate('form.input.dokument.grundSonstiges')}"
              .readonly="${this.preview}">
            </isceco-text-input>
          ` : ''}

          <isceco-dropdown
            label="${this.i18n.translate('form.input.dokument.rechtsform')}"
            name="rechtsform"
            required
            .readonly="${this.preview}"
            .i18n="${this.i18n}"
            .items="${this.rechtsformItems}"
            style="width: 100%">
          </isceco-dropdown>
      </isceco-card>

      <isceco-card text="${this.i18n.translate('form.title.bautraeger')}" class="form-card">
        ${this.i18n.translate('form.input.bautraeger.hinweis')}
        <div class="single-line">
          <isceco-text-input
            name="bautraeger.name"
            label="${this.i18n.translate('form.input.bautraeger.name')}"
            required
            .readonly="${this.preview}"
            style="flex-grow: 1"
            help-text="${this.i18n.translate('form.input.bautraeger.name.help')}"
          ></isceco-text-input>
        </div>
        <div class="single-line">
          <isceco-text-input
            name="bautraeger.strasse"
            label="${this.i18n.translate('form.input.bautraeger.strasse')}"
            required
            style="flex-grow: 0.8"
            .readonly="${this.preview}"></isceco-text-input>

          <isceco-text-input
            name="bautraeger.hausnummer"
            label="${this.i18n.translate('form.input.bautraeger.hausnummer')}"
            required
            style="flex-grow: 0.2"
            .readonly="${this.preview}"
          ></isceco-text-input>
        </div>

        <div class="single-line">
          <isceco-number-input
            label="${this.i18n.translate('form.input.bautraeger.plz')}"
            name="bautraeger.plz"
            required
            min="1000"
            max="9999"
            maximum-fraction-digits="0"
            style="flex-grow: 0.2"
            .readonly="${this.preview}"></isceco-number-input>

          <isceco-text-input
            name="bautraeger.ort"
            label="${this.i18n.translate('form.input.bautraeger.ort')}"
            required
            style="flex-grow: 0.8"
            .readonly="${this.preview}">
          </isceco-text-input>
        </div>
      </isceco-card>

      ${this.renderKontaktperson()}
      <isceco-card text="${this.i18n.translate('form.title.artikel')}" class="form-card"
                   help-text="${this.i18n.translate('form.input.artikel.help')}">
         ${this.i18n.translate('form.input.artikel.hinweis')}
        <isceco-text-input
          name="artikel.zweck"
          label="${this.i18n.translate('form.input.artikel.zweck')}"
          required
          pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
          pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
          style="flex-grow: 1.0"
          .readonly="${this.preview}"
        ></isceco-text-input>

          <isceco-text-input
            name="artikel.dividendenbeschraenkung"
            label="${this.i18n.translate('form.input.artikel.dividendenbeschraenkung')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.tantiemenverzicht"
            label="${this.i18n.translate('form.input.artikel.tantiemenverzicht')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.rechnungslegung"
            label="${this.i18n.translate('form.input.artikel.rechnungslegung')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.revision"
            label="${this.i18n.translate('form.input.artikel.revision')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.rueckzahlung"
            label="${this.i18n.translate('form.input.artikel.rueckzahlung')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.liquidationsgewinn"
            label="${this.i18n.translate('form.input.artikel.liquidationsgewinn')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>

          <isceco-text-input
            name="artikel.statutenaenderung"
            label="${this.i18n.translate('form.input.artikel.statutenaenderung')}"
            required
            pattern="${StatutenPruefung.ARTIKEL_PATTERN}"
            pattern-error-text="${this.i18n.translate(StatutenPruefung.I18N_KEYS.ARTIKEL_ERROR_TEXT)}"
            style="flex-grow: 1.0"
            .readonly="${this.preview}"
          ></isceco-text-input>
        </div>

      </isceco-card>
      <isceco-card text="${this.i18n.translate('form.input.dokument.kommentar')}" class="form-card">
        <isceco-text-input
          name="kommentar"
          textarea
          style="flex-grow: 0.5"
          .readonly="${this.preview}">
        </isceco-text-input>
      </isceco-card>
    `
  }
  renderKontaktperson(){
    return html`
      <isceco-card text="${this.i18n.translate('form.title.kontaktperson')}" class="form-card"
                   help-text="${this.i18n.translate('form.input.kontaktperson.help')}">
        <isceco-radio-group
          name="kontaktperson.geschlecht"
          label="${this.i18n.translate('form.input.kontaktperson.geschlecht')}"
          required
          .items="${[
            {
              value: 'männlich',
              name: this.i18n.translate('form.input.kontaktperson.geschlecht.maennlich')
            },
            {
              value: 'weiblich',
              name: this.i18n.translate('form.input.kontaktperson.geschlecht.weiblich')
            },
            {
              value: 'keine Angabe',
              name: this.i18n.translate('form.input.kontaktperson.geschlecht.keine')
            }
          ]}"
          .readonly="${this.preview}"
        ></isceco-radio-group>
        <div class="single-line">
          <isceco-text-input
            name="kontaktperson.vorname"
            label="${this.i18n.translate('form.input.kontaktperson.vorname')}"
            .value="${this._getAttributeFromTokenParsed('given_name')}"
            required
            style="flex-grow: 0.5"
            .readonly="${this.preview}">
          </isceco-text-input>
          <isceco-text-input
            name="kontaktperson.name"
            label="${this.i18n.translate('form.input.kontaktperson.name')}"
            .value="${this._getAttributeFromTokenParsed('family_name')}"
            required
            style="flex-grow: 0.5"
            .readonly="${this.preview}">
          </isceco-text-input>
        </div>
        <div class="single-line">
          <isceco-text-input
            name="kontaktperson.telefonNr"
            label="${this.i18n.translate('form.input.kontaktperson.telefonNr')}"
            pattern="^((\\+41|0041|0)([1-9][0-9]))\\s?\\d{3}\\s?\\d{2}\\s?\\d{2}$"
            .readonly="${this.preview}"
            style="flex-grow: 0.5"
          ></isceco-text-input>

          <isceco-text-input
            name="kontaktperson.email"
            label="${this.i18n.translate('form.input.kontaktperson.email')}"
            .value="${this._getAttributeFromTokenParsed('email')}"
            required
            type="email"
            .readonly="${this.preview}"
            style="flex-grow: 0.5"
          ></isceco-text-input>
        </div>
      </isceco-card>`
  }

  _updateGrundSonstigesRequiredState = e => {
    const grundDropdown = this.querySelector('isceco-dropdown[name="grundBescheinigung"]');
    const input = this.querySelector('isceco-text-input[name="grundSonstiges"]');
    const rechtsformDropdown = this.querySelector('isceco-dropdown[name="rechtsform"]');

    const value = e.detail.value;

    this._setRequiredIfDropdownValue(grundDropdown, input);

    if (value === 'WBG_BP') {
      rechtsformDropdown.value = 'GENOSSENSCHAFT';
      rechtsformDropdown.setAttribute('disabled', 'true');
    } else {
      rechtsformDropdown.removeAttribute('disabled');
    }

    this.selectedGrund = value;
    this.render();
  };

  _setRequiredIfDropdownValue = (dropdown, input, triggerValue = 'SONSTIGES') => {
    if (!dropdown || !input) {
      return;
    }
    const value = dropdown.value;
    if (!value || value === triggerValue) {
      input.setAttribute('required', '');
    } else {
      input.removeAttribute('required');
    }
  };

  _submit = event => {
    if (!this.preview) {
      this.preview = true
      this.render()
      return
    }

    new StatutenPruefungService().submit(event.detail, event.target)
  }

  grundBescheinigungItems = [
    {value: 'FDR', name: 'form.input.dokument.grund.FdR'},
    {value: 'EGW', name: 'form.input.dokument.grund.EGW'},
    {value: 'WFG', name: 'form.input.dokument.grund.WFG'},
    {value: 'WBG_BP', name: 'form.input.dokument.grund.WBG_BP'},
    {value: 'WEG', name: 'form.input.dokument.grund.WEG'},
    {value: 'SONSTIGES', name: 'form.input.dokument.grund.Sonstiges'}
  ];

  rechtsformItems = [
    {value: 'GENOSSENSCHAFT', name: 'form.input.dokument.rechtsform.Genossenschaft'},
    {value: 'STIFTUNG', name: 'form.input.dokument.rechtsform.Stiftung'},
    {value: 'VEREIN', name: 'form.input.dokument.rechtsform.Verein'},
    {value: 'AKTIENGESELLSCHAFT', name: 'form.input.dokument.rechtsform.Aktiengesellschaft'}
  ];
  getLocalizedDocumentLink() {
    const lang = this.getCurrentLang();
    return StatutenPruefung.DOCUMENT_LINKS[lang] || DOCUMENT_LINKS.de;
  }
  getCurrentLang() {
    return localStorage.getItem('eform-frontend-language') || 'de';
  }
}
customElements.define('eform-frontend-wbf-bwo-statutenpruefung', StatutenPruefung)
